const Loading = () => (
	<img
		src="/images/loading.gif"
		alt="Loading..."
		style={{ width: 250, height: 350 }}
	/>
);

export default Loading;
